import { useEffect, useState } from "react";

import styles from "../../../../styles/mensageria.module.scss";

import { Button } from "../../../components/Button";
import { Hairline } from "../../../components/Hairline";
import { Input } from "../../../components/Input";
import { Label } from "../../../components/Label";
import { Radio } from "../../../components/Radio";
import { Textarea } from "../../../components/Textarea";
import { If } from "../../../components/control-statements";
import { Environment } from "../../../core/Environment";
import { TemplateButtons } from "./TemplateButtons";

const headerTypes = {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  VIDEO: "VIDEO",
};

const MAX_CHARS_RECOMENDATION = 60;

export const TemplateConfig = ({
  template,
  setup,
  nextStep,
  onChangeTemplate,
}) => {
  const [headerType, setHeaderType] = useState(
    headerTypes[template?.structure?.header?.format]
  );

  useEffect(() => {
    setHeaderType(headerTypes[template?.structure?.header?.format]);
  }, [template?.structure?.header?.format]);

  const updateTemplate = (fields) => {
    onChangeTemplate({
      ...template,
      ...fields,
    });
  };

  const checkInvalidTemplate = () => {
    if (setup?.header) {
      const headerFormat = template?.structure?.header?.format;

      if (
        headerFormat === headerTypes.TEXT &&
        !template?.structure?.header?.text?.length
      )
        return true;

      if (
        [headerTypes.IMAGE, headerTypes.VIDEO].includes(headerFormat) &&
        !template?.structure?.header?.example?.length
      )
        return true;
    }

    if (setup?.footer && !template?.structure?.footer?.text) return true;

    if (!template?.structure?.body?.text) return true;

    return false;
  };

  const uploadResource = async ({ environmentId, file, mimeType }) => {
    // const sendVideoReq = await FlowAPI.putWhatsappResource({
    //   environmentId,
    //   file,
    //   mimeType,
    // });
    // const sentVideo = sendVideoReq.getData({});
    // const filePath = sentVideo?.filePath;
    // return { filePath };
  };

  const uploadImage = async (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    if (file) {
      const maxFileSize = 16;
      const fileSize = file.size / 1024 / 1024;
      const fileType = file.type;
      const fileName = file.name;

      if (fileSize > maxFileSize) {
        alert({ text: `Escolha um arquivo com no máximo ${maxFileSize}MB` });
        return false;
      }

      if (!["image/jpg", "image/jpeg", "image/png"].includes(fileType)) {
        alert({ text: "Arquivo inválido." });
        return false;
      }

      reader.onload = async (readerEvent) => {
        const file64 = readerEvent.target.result.split("base64,")[1];

        const sentResource = await uploadResource({
          environmentId: Environment.id,
          file: file64,
          mimeType: fileType,
        });
        const filePath = sentResource?.filePath;

        if (filePath) {
          updateTemplate({
            structure: {
              ...template.structure,
              header: {
                ...template?.structure?.header,
                fileName,
                fileSize: file.size,
                example: filePath,
              },
            },
          });
        } else {
          alert({ text: "Erro ao enviar arquivo de imagem, tente novamente!" });
        }
      };

      reader.readAsDataURL(file);
    }
  };

  const uploadVideo = async (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    if (file) {
      const maxFileSize = 16;
      const fileSize = file.size / 1024 / 1024;
      const fileType = file.type;
      const fileName = file.name;

      if (fileSize > maxFileSize) {
        alert({ text: `Escolha um arquivo com no máximo ${maxFileSize}MB` });
        return false;
      }

      if (!["video/mp4"].includes(fileType)) {
        alert({ text: "Arquivo inválido." });
        return false;
      }

      reader.onload = async (readerEvent) => {
        const file64 = readerEvent.target.result.split("base64,")[1];

        const sentResource = await uploadResource({
          environmentId: Environment.id,
          file: file64,
          mimeType: fileType,
        });
        const filePath = sentResource?.filePath;

        if (filePath) {
          updateTemplate({
            structure: {
              ...template.structure,
              header: {
                ...template?.structure?.header,
                fileName,
                fileSize: file.size,
                example: filePath,
              },
            },
          });
        } else {
          alert({ text: "Erro ao enviar arquivo de vídeo, tente novamente!" });
        }
      };

      reader.readAsDataURL(file);
    }
  };

  const getReplaceTagsExamples = (text) => {
    const examples = ["CUPOM-10A", "10"];

    if (text.match(/\{\{1\}\}/gi) && text.match(/\{\{2\}\}/gi)) {
      return examples;
    }

    if (text.match(/\{\{1\}\}/gi)) {
      return [examples[0]];
    }

    if (text.match(/\{\{2\}\}/gi)) {
      return [examples[1]];
    }

    return [];
  };

  return (
    <div className={styles.scrollContainer}>
      <div className={styles.know}>
        Saiba como ter seu template aprovado.&nbsp;
        <a href="#!">Saiba mais</a>
      </div>

      <If cond={setup?.header}>
        <Label className="mt-30">Cabeçalho</Label>
        <Radio
          value={headerTypes.TEXT}
          checked={headerType}
          onChange={() =>
            updateTemplate({
              structure: {
                ...template?.structure,
                header: { text: null, format: headerTypes.TEXT },
              },
            })
          }
          className="mb-10"
        >
          Texto
        </Radio>
        <Radio
          value={headerTypes.IMAGE}
          checked={headerType}
          onChange={() =>
            updateTemplate({
              structure: {
                ...template?.structure,
                header: { example: null, format: headerTypes.IMAGE },
              },
            })
          }
          className="mb-10"
        >
          Imagem
        </Radio>
        <Radio
          value={headerTypes.VIDEO}
          checked={headerType}
          onChange={() =>
            updateTemplate({
              structure: {
                ...template?.structure,
                header: { example: null, format: headerTypes.VIDEO },
              },
            })
          }
        >
          Vídeo
        </Radio>

        <Hairline solid className="mt-20 mb-15" />
        <If cond={headerType === headerTypes.TEXT}>
          <Input
            label="Texto do cabeçalho"
            value={template?.structure?.header?.text}
            onChange={(e) =>
              updateTemplate({
                structure: {
                  ...template?.structure,
                  header: {
                    ...template?.structure?.header,
                    text: e.target.value,
                  },
                },
              })
            }
          />
        </If>
        <If cond={headerType === headerTypes.IMAGE}>
          <label htmlFor="upload-image" className={styles.uploadContainer}>
            <input
              type="file"
              id="upload-image"
              accept=".jpg, .jpeg, .png"
              onChange={(e) => uploadImage(e.target.value)}
              disabled={template?.structure?.header?.example?.length}
            />

            <div className={styles.icon}>
              <i className="far fa-upload" />
            </div>

            <div className={styles.selectFile}>
              <p>Selecione o arquivo</p>
              <span>para fazer upload</span>
            </div>

            <p className={styles.accepted}>JPG, JPEG ou PNG de até 16MB.</p>
          </label>
        </If>
        <If cond={headerType === headerTypes.VIDEO}>
          <label htmlFor="upload-video" className={styles.uploadContainer}>
            <input
              type="file"
              id="upload-video"
              accept=".mp4"
              onChange={(e) => uploadVideo(e.target.value)}
              disabled={template?.structure?.header?.example?.length}
            />

            <div className={styles.icon}>
              <i className="far fa-upload" />
            </div>

            <div className={styles.selectFile}>
              <p>Selecione o arquivo</p>
              <span>para fazer upload</span>
            </div>

            <p className={styles.accepted}>MP4 de até 16MB.</p>
          </label>
        </If>
        <If
          cond={
            [headerTypes.IMAGE, headerTypes.VIDEO].includes(headerType) &&
            template?.structure?.header?.example
          }
        >
          <div className={styles.uploadProgress}>
            <div className="d-flex align-center">
              <div className={styles.icon}>
                <i className="fas fa-file" />
              </div>

              <div className="d-flex flex-column justify-center">
                <p className={styles.fileName}>
                  {template?.structure?.header?.fileName ||
                    template?.structure?.header?.example}
                </p>
                {template?.structure?.header?.fileSize && (
                  <p className={styles.fileSize}>
                    {(
                      template?.structure?.header?.fileSize /
                      (1024 * 1024)
                    ).toFixed(2)}
                    MB
                  </p>
                )}
              </div>
            </div>

            <div className="d-flex flex-column">
              <div
                className={styles.remove}
                onClick={() => {
                  updateTemplate({
                    structure: {
                      ...template?.structure,
                      header: {
                        ...template?.structure?.header,
                        example: null,
                      },
                    },
                  });

                  if (
                    template?.structure?.header?.format === headerTypes.IMAGE
                  ) {
                    document.getElementById("upload-image").value = "";
                  }
                  if (
                    template?.structure?.header?.format === headerTypes.VIDEO
                  ) {
                    document.getElementById("upload-video").value = "";
                  }
                }}
              >
                <i className="fas fa-times" />
              </div>
              {/* <p className={styles.percentage}>65%</p> */}
            </div>
          </div>
        </If>

        <Hairline className="mt-20" />
      </If>

      <Label className="mt-30 mb-25">Corpo</Label>
      <Textarea
        minHeight={170}
        label="Texto do corpo"
        design="two"
        onChange={(e) =>
          onChangeTemplate({
            structure: {
              ...template.structure,
              body: {
                text: e.target.value,
                examples: getReplaceTagsExamples(e.target.value),
              },
            },
          })
        }
        value={template?.structure?.body?.text}
      />
      <div className={styles.info}>
        <div className="d-flex align-center">
          <div className={styles.dot} />
          <p>É possível inserir palavras em negrito utilizando *palavra*</p>
        </div>
      </div>
      <div className={styles.info}>
        <div className="d-flex align-center">
          <div className={styles.dot} />
          <p>Insira lacunas para os dados do criativo da seguinte maneira:</p>
        </div>

        <div className={styles.gaps}>
          <span>
            <strong>&#123;&#123;1&#125;&#125;</strong>
            &nbsp;- Código do cupom
          </span>
          <span>
            <strong>&#123;&#123;2&#125;&#125;</strong>
            &nbsp;- Benefício recebido
          </span>
        </div>
      </div>

      <If cond={setup?.footer}>
        <Hairline className="mt-20 mb-20" />
        <Label className="mb-25">Rodapé</Label>
        <Textarea
          minHeight={170}
          label="Texto do rodapé"
          onChange={(e) =>
            onChangeTemplate({
              ...template,
              structure: {
                ...template.structure,
                footer: { text: e.target.value },
              },
            })
          }
          value={template?.structure?.footer?.text}
          max="60"
        />
        <div className="d-flex justify-end">
          <p className={styles.charactersCount}>
            <span className={styles.type}>
              Máx {MAX_CHARS_RECOMENDATION} caracteres
            </span>
          </p>
        </div>
      </If>

      <If cond={setup?.buttons}>
        <Hairline className="mt-20 mb-20" />
        <TemplateButtons
          template={template}
          onChangeTemplate={onChangeTemplate}
        />
      </If>

      <div className={styles.footer}>
        <Button
          text="Avançar"
          design="primary"
          className="w-100"
          disabled={checkInvalidTemplate()}
          onClick={nextStep}
        />
      </div>
    </div>
  );
};
